function setupCountryList() {
	const countryList = document.getElementById('CountryList');
	if (!countryList) return;

	// Initial backup of the original list items
	if (!countryList.dataset.initialHtml) {
		countryList.dataset.initialHtml = countryList.innerHTML;
	}

	const countryListItems = Array.from(
		new DOMParser().parseFromString(countryList.dataset.initialHtml, 'text/html').querySelectorAll('li')
	);

	const americasCode = ['US', 'CA', 'MX', 'BR', 'AR', 'CL', 'CO', 'PA'];
	const asiaCode = ['AU', 'JP', 'KR', 'CN', 'HK', 'MO', 'TW', 'IN', 'ID', 'PH', 'SG', 'TH', 'AE', 'BH', 'OM', 'QA', 'KW', 'SA'];
	const europeCode = [
		'FR', 'DE', 'IT', 'ES', 'GB', 'NL', 'BE', 'AT', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'GR', 'HU', 'IS', 'IE',
		'LV', 'LI', 'LT', 'LU', 'MT', 'NO', 'PL', 'PT', 'RO', 'SK', 'SI', 'SE', 'CH', 'MC', 'AD', 'ME'
	];

	const americas = [];
	const asia = [];
	const europe = [];
	const other = [];

	countryListItems.forEach(country => {
		const continentOption = country.querySelector('[data-option]');
		if (!continentOption) { return }
		const continent = continentOption.dataset.option;
		if (!continent) { return }
		if (americasCode.includes(continent)) {
			americas.push(country);
		} else if (asiaCode.includes(continent)) {
			asia.push(country);
		} else if (europeCode.includes(continent)) {
			europe.push(country);
		} else {
			other.push(country);
		}
	});

	const sortByName = (a, b) => {
		const nameA = a.innerText.trim();
		const nameB = b.innerText.trim();
		return nameA.localeCompare(nameB, 'fr', { sensitivity: 'base' });
	};

	americas.sort(sortByName);
	asia.sort(sortByName);
	europe.sort(sortByName);
	other.sort(sortByName);

	function getNumberOfColumns() {
		const width = window.innerWidth;
		if (width >= 1600) {
			return 4;
		}
		if (width >= 1200) {
			return 3;
		}
		return 2;
	}

	function reorderForColumns(list, cols) {
		if (cols <= 1) {
			return list;
		}
		const reordered = [];
		const baseNumRows = Math.floor(list.length / cols);
		const extraItems = list.length % cols;
		const columns = [];

		let startIndex = 0;
		for (let c = 0; c < cols; c++) {
			const numRows = baseNumRows + (c < extraItems ? 1 : 0);
			columns.push(list.slice(startIndex, startIndex + numRows));
			startIndex += numRows;
		}

		const maxRows = columns[0] ? columns[0].length : 0;
		for (let r = 0; r < maxRows; r++) {
			for (let c = 0; c < cols; c++) {
				if (columns[c] && columns[c][r]) {
					reordered.push(columns[c][r]);
				}
			}
		}

		return reordered;
	}

	const numCols = getNumberOfColumns();

	const reorderedAmericas = reorderForColumns(americas, numCols);

	// Group CN, HK, MO, TW under a China subgroup (extract BEFORE reordering for columns)
	const chinaCodes = ['CN', 'HK', 'MO', 'TW'];
	function extractByCode(list, codes) {
		const found = [];
		const rest = [];
		list.forEach(li => {
			const el = li.querySelector('[data-option]');
			const code = el && el.dataset.option;
			if (code && codes.includes(code)) {
				found.push(li);
			} else {
				rest.push(li);
			}
		});
		return { found, rest };
	}

	const { found: chinaItems, rest: asiaWithoutChina } = extractByCode(asia, chinaCodes);

	let chinaTitle = 'China';
	let cnItem = null;
	const otherChinaItems = [];
	chinaItems.forEach(li => {
		const el = li.querySelector('[data-option]');
		const code = el && el.dataset.option;
		if (code === 'CN') {
			cnItem = li;
			const text = li.innerText.trim();
			const idx = text.indexOf('(');
			chinaTitle = idx > 0 ? text.slice(0, idx).trim() : text;
		} else {
			otherChinaItems.push(li);
		}
	});
	otherChinaItems.sort(sortByName);
	const orderedChinaItems = [];
	if (cnItem) orderedChinaItems.push(cnItem);
	orderedChinaItems.push(...otherChinaItems);

	// Si on a moins de 2 items China, on les remet dans la liste principale
	let finalAsiaList = asiaWithoutChina;
	if (orderedChinaItems.length < 2) {
		finalAsiaList = [...asiaWithoutChina, ...orderedChinaItems];
		finalAsiaList.sort(sortByName);
		orderedChinaItems.length = 0; // Vider la liste pour ne pas afficher le sous-groupe
	}

	const reorderedAsiaWithoutChina = reorderForColumns(finalAsiaList, numCols);
	const reorderedEurope = reorderForColumns(europe, numCols);
	const reorderedOther = reorderForColumns(other, numCols);

	countryList.innerHTML = '';

	if (americas.length > 0) {
		let blockHTML = `<li class="continent-group americas-group">`;
		blockHTML += `<div class="continent--title mb-[8px] w-full px-[12px] lg:px-[16px]">${window.localizationStrings.america}</div>`;
		blockHTML += `<ul class="countries-sublist">`;
		reorderedAmericas.forEach(countryName => {
			blockHTML += countryName.outerHTML;
		});
		blockHTML += `</ul>`;
		blockHTML += `</li>`;
		countryList.innerHTML += blockHTML;
	}

	if (asia.length > 0) {
		let blockHTML = `<li class=\"continent-group asia-group\">`;
		blockHTML += `<div class=\"continent--title mb-[8px] w-full px-[12px] lg:px-[16px]\">${window.localizationStrings.asia}</div>`;
		blockHTML += `<ul class=\"countries-sublist\">`;

		// Render Asia countries (includes China items if less than 2)
		reorderedAsiaWithoutChina.forEach(countryName => {
			blockHTML += countryName.outerHTML;
		});

		// Then render China subgroup if we have at least 2 items (CN + at least one other)
		if (orderedChinaItems.length > 0) {
			blockHTML += `<li class=\"country-subgroup china-subgroup\">`;
			blockHTML += `<ul class=\"subgroup-countries\">`;
			orderedChinaItems.forEach(li => {
				const html = li.outerHTML;
				const match = html.match(/data-option=\"([A-Z]{2})\"/);
				const code = match && match[1];
				
				// Détection de la langue actuelle
				const currentLang = document.documentElement.lang || 'en';
				const isFrench = currentLang.startsWith('fr');
				
				if (code === 'CN') {
					// Afficher CN comme titre/bouton principal (sans flèche, sans décalage)
					blockHTML += html;
				} else if (code) {
					let modifiedHtml = html;
					
					// Extraire le texte du pays pour le wrapper séparément
					const textMatch = modifiedHtml.match(/<span class="text-left inline[^>]*>([^<]+)<\/span>/);
					const countryText = textMatch ? textMatch[1] : '';
					
					// Remplacer SAR par R.A.S en français pour HK et MO
					let finalCountryText = countryText;
					if (isFrench && (code === 'HK' || code === 'MO')) {
						finalCountryText = finalCountryText.replace(/\bSAR\b/g, 'R.A.S');
					}
					
					// Pour Taiwan : Région de Taïwan (en français) ou Region of Taiwan (en anglais)
					if (code === 'TW') {
						if (isFrench) {
							// En français : Région de Taïwan (avec tréma)
							finalCountryText = finalCountryText.replace(/(Ta[ïi]wan)/g, 'Région de $1');
						} else {
							// En anglais : Region of Taiwan
							finalCountryText = finalCountryText.replace(/(Taiwan)/g, 'Region of $1');
						}
					}
					
					// Restructurer : flèche en dehors du span avec btn-link, texte dans un span avec btn-link
					const greyArrow = '<span style="color: hsl(var(--b3) / var(--tw-text-opacity));">&gt; </span>';
					const wrappedText = `<span class="btn btn-link !p-0 min-h-fit leading-[16px] inline">${finalCountryText}</span>`;
					modifiedHtml = modifiedHtml.replace(/<span class="text-left inline btn btn-link[^>]*>[^<]+<\/span>/, greyArrow + wrappedText);
					
					blockHTML += modifiedHtml;
				}
			});
			blockHTML += `</ul>`;
			blockHTML += `</li>`;
		}

		blockHTML += `</ul>`;
		blockHTML += `</li>`;
		countryList.innerHTML += blockHTML;
	}

	if (europe.length > 0) {
		let blockHTML = `<li class="continent-group europe-group">`;
		blockHTML += `<div class="continent--title mb-[8px] w-full px-[12px] lg:px-[16px]">${window.localizationStrings.europe}</div>`;
		blockHTML += `<ul class="countries-sublist">`;
		reorderedEurope.forEach(countryName => {
			blockHTML += countryName.outerHTML;
		});
		blockHTML += `</ul>`;
		blockHTML += `</li>`;
		countryList.innerHTML += blockHTML;
	}

	if (other.length > 0) {
		let blockHTML = `<li class="continent-group other-group">`;
		blockHTML += `<div class="continent--title mb-[8px] w-full px-[12px] lg:px-[16px]">${window.localizationStrings.other}</div>`;
		blockHTML += `<ul class="countries-sublist">`;
		reorderedOther.forEach(countryName => {
			blockHTML += countryName.outerHTML;
		});
		blockHTML += `</ul>`;
		blockHTML += `</li>`;
		countryList.innerHTML += blockHTML;
	}
}

document.addEventListener('DOMContentLoaded', () => {
	setupCountryList();
	window.addEventListener('resize', setupCountryList);
});

class SizeGuideTabs extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.buttons = this.querySelectorAll('[data-size-guide-btn]');
		this.tabs = this.querySelectorAll('[data-size-guide-tab-item]');

		if (!this.buttons?.length > 0 || !this.tabs?.length > 0) return;

		this.buttons.forEach(button => {
			button.addEventListener('click', () => this.handleButtonClick(button));
		});
	}

	disconnectedCallback() {
		this.buttons?.forEach(button => {
			button.removeEventListener('click', () => this.handleButtonClick(button));
		});
	}

	handleButtonClick(button) {
		this.buttons.forEach(button => button.classList.remove('active'));
		button.classList.add('active');

		this.tabs.forEach(tab => {
			if (tab.dataset.sizeGuideTab === button.dataset.sizeGuideTab) {
				tab.classList.add('active');
			} else {
				tab.classList.remove('active');
			}
		});
	}
}

customElements.get('size-guide-tabs') || customElements.define('size-guide-tabs', SizeGuideTabs);